import { ISettingsVO } from 'library/ts/interfaces/settings/ISettingsVO';
import { CCSettingsVO } from 'library/ts/model/settings/CCSettingsVO';
import { SettingsDefault } from 'library/ts/model/settings/SettingsDefault';
import { IAudioTrack } from 'library/ts/player/adapter/interfaces/audio/IAudioTrack';

/**
 * @copyright © Paramount Streaming
 * @author Stan Gletski
 * @description Settings object...
 */
export class SettingsVO implements ISettingsVO {

	/**
	 * @description Timestamp of last Settings VO update
	 * @type {Date}
	 */
	timestamp: Date = new Date();

	/**
	 * @description Audio Track object for persistent Multi Track Audio
	 * @type {IAudioTrack}
	 */
	audioTrack: IAudioTrack = undefined;

	/**
	 * @description Sound volume value 0-1
	 * @type {number}
	 */
	volume: number = SettingsDefault.VOLUME;

	/**
	 * @description Mute state
	 * @type {boolean}
	 */
	mute: boolean = false;

	/**
	 * @description Dynamic bitrate switching flag
	 * @type {boolean}
	 */
	useDynamicSwitching: boolean = false;

	/**
	 * @description LTS Feature Tooltip counter record per profile
	 * @type {Record<string, number>}
	 */
	ltsFeatureTooltip: Record<string, number> = undefined;

	/**
	 * @description Related Videos Feature Tooltip counter per profile
	 * @type {Object}
	 */
	highlightsFeatureTooltip: Record<string, number>;

	/**
	 * @description Multi Stream Feature Tooltip counter per profile
	 * @type {Object}
	 */
	multiviewFeatureTooltip: Record<string, number>;

	/**
	 * @description Closed Captions styling settings
	 * @type {CCSettingsVO}
	 */
	ccSettingsVO: CCSettingsVO = new CCSettingsVO();
}